import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuration } from 'src/app/app.constants';
import { ClimatiqRegionViewModel } from '../viewModels/climatiq/climatiqRegionViewModel';
import { Observable } from 'rxjs';
import { ClimatiqSourceViewModel } from '../viewModels/climatiq/climatiqSourceViewModel';
import { ClimatiqEmissionFactorSearchViewModel } from '../viewModels/climatiq/climatiqEmissionFactorSearchViewModel';
import { ClimatiqIndicatorEstimateParameterSelectorViewModel } from '../viewModels/climatiq/climatiqIndicatorEmissionsDataSelectorViewModel';
import { ClimatiqUnitTypeViewModel } from '../viewModels/climatiq/climatiqUnitTypeViewModel';
import { ClimatiqSectorViewModel } from '../viewModels/climatiq/climatiqSectorViewModel';

@Injectable({
  providedIn: 'root',
})
export class ClimatiqService {

  constructor(
    private http: HttpClient,
    private configuration: Configuration
  ) {
    
  }

  /**
   * Getter that dynamically builds the actionUrl each time.
   * This ensures the URL updates when the backend API changes (e.g., account switching).
   */
  private get actionUrl(): string {
    return this.configuration.buildEndpoint(`Sustainability/Climatiq/`);
  }

  // Get Climatiq-related Data

  getClimatiqRegions(): Observable<ClimatiqRegionViewModel[]> {
    return this.http.get<ClimatiqRegionViewModel[]>(`${this.actionUrl}ClimatiqRegions`);
  }

  getClimatiqUnitTypes(): Observable<ClimatiqUnitTypeViewModel[]> {
    return this.http.get<ClimatiqUnitTypeViewModel[]>(`${this.actionUrl}ClimatiqUnitTypes`);
  }

  getClimatiqSectors(): Observable<ClimatiqSectorViewModel[]> {
    return this.http.get<ClimatiqSectorViewModel[]>(`${this.actionUrl}ClimatiqSectors`);
  }

  getClimatiqSources(): Observable<ClimatiqSourceViewModel[]> {
    return this.http.get<ClimatiqSourceViewModel[]>(`${this.actionUrl}ClimatiqSources`);
  }

  // Emission Factor data

  getEmissionFactorSearchResults(searchModel: ClimatiqEmissionFactorSearchViewModel){
    return this.http.post<ClimatiqIndicatorEstimateParameterSelectorViewModel[]>(`${this.actionUrl}EmissionFactorSearchResults`, searchModel);
  }

}
